import styled from "styled-components";

const colorVariants = {
  blue:   { normal: "#0d6efd", hover: "#0b5ed7" }, // Azul primario
  green:  { normal: "#198754", hover: "#157347" }, // Verde éxito
  red:    { normal: "#dc3545", hover: "#bb2d3b" }, // Rojo peligro
  gray:   { normal: "#6c757d", hover: "#5c636a" }, // Gris neutro
  yellow: { normal: "#ffc107", hover: "#e0a800" }, // Amarillo advertencia
  orange: { normal: "#fd7e14", hover: "#e56706" }, // Naranja vibrante
  cyan:   { normal: "#22b8d6ff", hover: "#0891b2" }, // Informativo
  purple: { normal: "#6f42c1", hover: "#5936a2" }, // Morado elegante
  teal:   { normal: "#20c997", hover: "#198754" }, // Verde-azulado fresco
  pink:   { normal: "#d63384", hover: "#b02a66" }, // Rosa destacado
  black:  { normal: "#212529", hover: "#000000" }, // Negro intenso
  white:  { normal: "#f8f9fa", hover: "#e9ecef" }, // Blanco/gris claro
  excel:  { normal: "#217346", hover: "#185C37" }
};


export const BtnGeneral = styled.button.attrs((props) => ({
  type: props.type || "button",
}))`
  flex: ${({ flex }) => flex || ""};
  text-align: center;
  padding: ${({ padding }) => padding || "5px 12px"};
  font-size: ${({ fs }) => fs || "var(--app-font-size)"};
  font-weight: ${({ fw }) => fw || "normal"};
  font-family: var(--font-body);
  border: ${({ border }) => border || "none"};
  border-radius: ${({ radius }) => radius || "5px"};
  text-decoration: none;
  color: ${({ color }) => color || "white"};
  background: ${({ bg }) => (colorVariants[bg]?.normal || (bg && !colorVariants[bg] ? bg : "#0d6efd"))};
  display: ${({ dp }) => dp || "flex"};
  align-items: center;
  justify-content: center;
  gap: ${({ gap }) => gap || "4px"};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  margin-bottom: ${({ mgb, mg }) => mgb || mg || ""};
  margin-top: ${({ mgt }) => mgt || ""};
  margin-left: ${({ mgl }) => mgl || ""};
  margin-right: ${({ mgr }) => mgr || ""};
  transition: ${({ trbg }) => trbg || "background 0.15s ease, opacity 0.15s ease"};
  width: ${({ w }) => w || ""};
  position: ${({ position }) => position || ""};
  right: ${({ r }) => r || ""};
  top: ${({ t }) => t || ""};
  outline: none;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    background: ${({ bg }) => (colorVariants[bg]?.hover || (bg && !colorVariants[bg] ? bg : "#0b5ed7"))};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: none;
  }
`;


export const BtnBlue = styled.button`
  background: #0077b6;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #0056b3;
  }
`;

export const BtnGreen = styled.button`
  background: #28a745;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #1b7c3bee;
  }
`;

export const BtnSlateGray = styled.button`
  background: #68737e;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #505a63;
  }
`;
